import React, {Component}   from 'react';
import PropTypes            from 'prop-types';
import FieldError           from '../Fragments/FieldError';

let HttpService = require('../Managers/HttpService');
let envConfig;
let Quote = require('../Managers/Quote.js');
let Validation = require('../Managers/Validation.js');
let FaSelector = require('react-icons/lib/fa/circle-o');

class TextInputWithSelectionList extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isHelpVisible: false,
            jobTitles: [],
            matches: [],
            activeValue: props.defaultValue ? props.defaultValue : '',
        };
    }

    /**
     * currently hard coded to work with only
     * job titles because the endpoint returns in valid
     * JSON, so we have to return it in the error, etc.
     * its basically a massive mess, apologies
     */
    componentWillMount() {
        try {
            $.ajax({
                type: envConfig.jobTitleLookup.method,
                url: envConfig.jobTitleLookup.url,
                dataType: 'application/json',
                success: function() {
                    // @TODO find a way to make this better
                },
                error: (response) => {
                    if (!window.uorn(response.responseText)) {
                        let data = JSON.parse(response.responseText);
                        let list = data.map(v => {
                            return v.title;
                        }).filter(v => {
                            return v != undefined;
                        });
                        this.setState({
                            jobTitles: list
                        });
                    }
                }
            });
        } catch (err) {
            this.setState({
                jobTitles: []
            });
        }

        if (this.props.defaultValue) {
            this.setState({isValid: true});
            this.props.isValid(true);
        }
        if (window.uorn(this.props.dataValidation)) {
            this.setState({isValid: true});
            this.props.isValid(true);
        }

        envConfig = HttpService.getConfigForHost();
    }

    handleValidation(value) {
        // if we have a default value, we have to pass validation
        if (this.props.defaultValue) {
            this.setState({isValid: true});
            this.props.isValid(true);
        }

        // if they dont have validation data, we assume they're valid
        let isValid = true;

        // if we have validation rules, attempt to validate
        if (this.props.dataValidation) {
            let validation = Validation.validate(this.props.dataValidation, value, 'not_null')[0];
            isValid = validation.isValid;
            this.setState(validation);
        }

        // regardless of if we're valid or not, set the active value
        this.setState({
            activeValue: value,
        }, () => {
            this.props.isValid(isValid);
        });

        // regardless of validation, set the state
        Quote.set(this.props.storageKey, value, this.props.source);
        Quote.setAnswer(this.props.storageKey, value);

        // if we have a callback, call that
        if (this.props.callbackFunction) {
            this.props.callbackFunction(value);
        }
    }

    getCurrentValue() {
        return this.state.activeValue;
    }

    /**
     * Searches within the provided list of employers for a match against the
     * user-provided input.
     *
     * @param e
     */
    onKeyUpFunc(e) {
        if (this.props.onKeyUpFunc) {
            this.props.onKeyUpFunc(e.key, e.target.value);
        }
        let matches = [];

        if (e.target.value.length > 2) {
            // then do the autocomplete
            matches = this.state.jobTitles.map(v => {
                if (v.toUpperCase().startsWith(e.target.value.toUpperCase())) {
                    return v;
                }
            }).filter(v => {
                return v != undefined;
            });
        } else {
            matches = [];
        }

        this.setState({
            matches,
            activeValue: e.target.value
        });
    }

    /**
     * Re-initiates an employer search if focus is given back tot he input.
     *
     * @param e
     */
    onFocus(e) {
        this.onKeyUpFunc(e);
    }

    /**
     * Actions when selecting one of the employer options.
     *
     * @param e
     */
    selectValue(e) {
        // todo: swap FaSelector for FaSelected on selected item
        this.setState({
            matches: []
        });
        document.getElementById(this.props.fieldName).value = e;

        this.setState({
            activeValue: e,
        });

        this.handleValidation(e);
    }

    render() {
        return (
            <div className="question-input">
                <input
                    name={this.props.fieldName}
                    id={this.props.fieldName}
                    type="text"
                    maxLength={this.props.maxLength}
                    onFocus={this.onFocus.bind(this)}
                    onBlur={(event) => { this.handleValidation(event.target.value); }}
                    onKeyUp={this.onKeyUpFunc.bind(this)}
                    defaultValue={this.props.defaultValue}
                />

                {this.state.hasError === true ?
                    <FieldError errors={this.state.errors} />
                :null}

                {this.state.matches && this.state.matches.length > 0 ?
                    <div className="constrained-selector">
                        <strong>We found the following job titles:</strong>
                        <ul>
                            {
                                this.state.matches.map((o, i) => {
                                    return(
                                        <li key={i} id={'option_' + i} onClick={() => {this.selectValue(o);}}>
                                            <FaSelector /> {o}
                                        </li>
                                    );
                                }, this)
                            }
                        </ul>
                    </div>
                :null}
            </div>
        );
    }
}

TextInputWithSelectionList.propTypes = {
    fieldName:          PropTypes.string.isRequired,
    question:           PropTypes.string.isRequired,
    maxLength:          PropTypes.number.isRequired,
    callbackFunction:   PropTypes.func,
    defaultValue:       PropTypes.string,
    dataValidation:     PropTypes.string,
    source:             PropTypes.string,
    storageKey:         PropTypes.string,
    isValid:            PropTypes.func,
    onKeyUpFunc:        PropTypes.func,
    selectionCriteria:  PropTypes.func,
};

export default TextInputWithSelectionList;


// WEBPACK FOOTER //
// ./src/components/Fields/TextInputWithSelectionList.js